<template>
  <div class="app-container">
    <app-search>
      <div slot="content">
        <el-form inline :model="listQuery" label-suffix="：" label-width="auto">
          <el-form-item
            :label="$t('vehicleAlarm.overspeedRule.ruleName')"
            label-width="auto"
          >
            <el-input
              v-model="listQuery.ruleName"
              :placeholder="$t('vehicleAlarm.overspeedRule.ruleName')"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 授权按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-rule="handleRule"
      @click-filter="showfilter = true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <el-button
            v-if="item.prop === 'carCount'"
            @click.native.prevent="viewCarInfo(scope.row)"
            type="text"
            size="small"
          >
            {{ scope.row[item.prop] || "/" }}
          </el-button>
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div v-else-if="item.prop === 'readOnly'">
            <span>{{
              scope.row[item.prop] === 1
                ? $t("carMonitor.electric.electricManage.readOnly")
                : $t("carMonitor.electric.electricManage.editable")
            }}</span>
          </div>
          <span v-else>{{ scope.row[item.prop] || "/" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增修改dialog -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit ? currentRow : {}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <!-- 车辆信息 -->
    <car-information
      :visible.sync="carVisible"
      :view="carView"
      :id="carVisible ? currentRow.ruleId : ''"
      :sub-id="carVisible ? currentRow.id : ''"
      @refresh="listLoad"
    />
  </div>
</template>
<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// request
import { overSpeedRuleListUrl, overSpeedRuleDeleteUrl } from '@/api/vehicleAlarm/overspeedRule'
import resolve from '@/api/resolve'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
import CarInformation from './components/carInformation'
export default {
  name: 'overspeedRule',
  components: {
    AddUpdateDialog,
    CarInformation
  },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  data() {
    return {
      listQuery: {},
      showfilter: false,
      tableList: [
        { value: this.$t('vehicleAlarm.overspeedRule.ruleName'), prop: 'ruleName', position: 'center', checked: true, sortable: true },
        { value: this.$t('vehicleAlarm.maxSpeed'), prop: 'maxSpeed', position: 'center', checked: true, sortable: true },
        { value: this.$t('vehicleAlarm.overspeedRule.carCount'), prop: 'carCount', position: 'center', checked: true, sortable: true },
        { value: this.$t('vehicleAlarm.overspeedRule.createdOn'), prop: 'createdOn', position: 'center', checked: true, sortable: true },
        { value: this.$t('carMonitor.electric.electricManage.createdByYou'), prop: 'readOnly', position: 'center', checked: true },
        { value: this.$t('vehicleAlarm.remark'), prop: 'remark', position: 'center', checked: true, sortable: true },
      ],
      authouizeList: [],
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false, // 新增修改dialog
      isEdit: false, // false: 新增, true:编辑
      carVisible: false,
      carView: false,
      currentRow: null,
    }
  },
  methods: {
    listLoad() {
      this.listLoading = true
      this.$http.post(overSpeedRuleListUrl, this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 检测是否未选择
    checkCurrentRowEmpty() {
      return !this.currentRow
    },
    handleCurrentRowChange(val) {
      this.currentRow = val
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增完成
    addComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.createSuccess'),
        duration: 2 * 1000
      })
    },
    // 编辑
    handleUpdate() {
      if (!this.checkCurrentRowEmpty()) {
        if (!this.currentRow.readOnly) {
          this.isEdit = true
          this.addUpdateVisible = true
        } else {
          this.$alert(this.$t('carMonitor.electric.electricManage.readOnlyTip'),
            this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define')
          })
        }
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => { })
          .catch(() => { })
      }
    },
    // 设置授权
    handleRule() {
      if (!this.checkCurrentRowEmpty()) {
        if (!this.currentRow.readOnly) {
          this.carView = false
          this.carVisible = true
        } else {
          this.$alert(this.$t('carMonitor.electric.electricManage.readOnlyTip'),
            this.$t('public.tips'), {
            confirmButtonText: this.$t('public.define')
          })
        }
      } else {
        this.$alert(this.$t('public.operationTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      }
    },
    // 查看已设规则车辆
    viewCarInfo(row) {
      this.currentRow = row
      this.carView = true
      this.carVisible = true
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.updateSuccess'),
        duration: 2 * 1000
      })
    },
    // 删除
    handleDelete() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      if (this.currentRow.readOnly) {
        this.$alert(this.$t('carMonitor.electric.electricManage.readOnlyTip'),
          this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      } else {
        this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
        })
          .then(() => {
            this.$http.delete(resolve(overSpeedRuleDeleteUrl, this.currentRow.ruleId)).then(({ data }) => {
              if (data.code === 0) {
                this.listLoad()
                this.$message.success({
                  message: this.$t('public.deleteSuccess'),
                  duration: 2 * 1000
                })
              }
            })
          })
      }
    },
  }
}
</script>
